import cn from 'classnames';
import styles from './DetailListRow.module.css';

type Props = {
  label: string;
  value: React.ReactNode;
  labelClassName?: string;
};

/**
 * Displays a key, value pair of host information as a row in a table.
 */
export function DetailListRow({ label, value, labelClassName }: Props) {
  return (
    <tr className={styles.DetailListRow}>
      <th scope="row" className={cn(styles.DetailListRow_name, labelClassName)}>
        {label}
      </th>
      <td className={styles.DetailListRow_value}>{value}</td>
    </tr>
  );
}
